export default "mutation saveAreasOfInterest ($areasOfInterest: AreasOfInterestInput!) {\n    saveAreasOfInterest (areasOfInterest: $areasOfInterest)\n}\n";